module.exports = __webpack_public_path__ + "775bfd0f1e6af0f789dd53048e6a82e7.fbx";